// Utilisateurs et rôles (modèle v2, docs/DATA_MODEL.md). Droits vérifiés par firestore.rules.
import { collection, doc, onSnapshot, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore';
import { db } from './firebase';

export const ROLES = {
  admin: 'Administrator',
  contributor: 'Contributor',
  viewer: 'Viewer',
  external: 'External (shared projects)',
};

export const isInternalRole = role => ['admin', 'contributor', 'viewer'].includes(role);

// Fiche users/{uid} : l'identifiant du document fait foi. Un champ « uid » saisi à la main (fiche créée ou dupliquée
// dans la console) est ignoré ; s'il diffère, il est rendu dans uidField pour le signaler.
function userData(id, data) {
  const { uid: field, ...rest } = data;
  return { ...rest, uid: id, ...(field != null && field !== id ? { uidField: field } : {}) };
}

// Profil de l'utilisateur connecté : objet, null si la fiche n'existe pas.
export function watchProfile(uid, onChange, onError) {
  return onSnapshot(doc(db(), 'users', uid),
    snap => onChange(snap.exists() ? userData(uid, snap.data()) : null),
    onError);
}

// Toutes les fiches, triées ici (un orderBy('email') de Firestore écarterait les fiches sans e-mail).
export function watchUsers(onChange, onError) {
  const key = u => (u.email || u.displayName || u.uid).toLowerCase();
  return onSnapshot(collection(db(), 'users'),
    snap => onChange(snap.docs.map(d => userData(d.id, d.data())).sort((a, b) => key(a).localeCompare(key(b), 'fr'))),
    onError);
}

// E-mail du compte de connexion recopié dans la fiche (champ saisi à la main, parfois faux ou absent) ; les règles
// n'acceptent que celui du compte connecté.
export const syncProfileEmail = (uid, email) => updateDoc(doc(db(), 'users', uid), { email });

export const setUserRole = (uid, role) => updateDoc(doc(db(), 'users', uid), { role });
export const setUserDisabled = (uid, disabled) => updateDoc(doc(db(), 'users', uid), { disabled });

// Fiche d'un compte déjà créé dans Firebase Authentication (en attendant les invitations par e-mail).
export const addUserProfile = (uid, { email, displayName, role }) =>
  setDoc(doc(db(), 'users', uid), { email, displayName, role, createdAt: serverTimestamp() });
